module.exports = __webpack_public_path__ + "static/media/twitter.69b41977.svg";